module.exports = __webpack_public_path__ + "img/background1.607ae36f.jpg";